import React, { Component } from 'react';
import { ReactComponent as PauseIcon } from '../build/images/pauseicon.svg';
import { connect } from 'react-redux';
import MicroModal from 'micromodal'; 
import { showmodalPause } from '../actions';

const { connection_platform } = require("../services/api")

var timeoutPause = 0;
var enableNotifier = false;
var reason = "";

const mapDispatchToProps = dispatch => {
  return {
      showmodalpause: (params) => {
        dispatch(showmodalPause(params))
      }
    };
};

const mapStateToProps = (state) => {
  return {
    StatusAgent: state.status,
    InfoUsers: state.informationusers
  };
}

 class TimePauseModal extends Component {
        constructor(props) {
            super(props);
            this.state = {
              isOpen: false,
            };
        }

        closeModal(){
           this.props.showmodalpause(false)
           timeoutPause = setTimeout(() => {
              this.props.showmodalpause(true)
            }, connection_platform.time_alert_pause);
            enableNotifier = true;
            reason = this.props.StatusAgent.reason;
        }

        componentDidUpdate(){
          if(this.props.StatusAgent.status !== 'Pausado' && enableNotifier === true){
            clearTimeout(timeoutPause);
            enableNotifier = false;
            reason = this.props.StatusAgent.reason;
          }

          if(reason !== this.props.StatusAgent.reason && this.props.StatusAgent.status === 'Pausado' && enableNotifier === true){
            clearTimeout(timeoutPause);
          }
              
        }

render(){

  const {InfoUsers} = this.props;

    return(  
      <div className={InfoUsers.showmodalpause ? "modal-overlay modal__pausa-errada active":"modal-overlay modal__pausa-errada"}>
          <div className="modal-box" style={{width: 400, height: 370}}>
            <div className="modal-box__content">
                <PauseIcon />
                <h4 className="modal-box__warning is-poppins pd-0">Você ultrapassou seu tempo de pausa</h4>
                <a onClick={event => this.closeModal(event)} className="modal-box__return-btn btn-return__pausa-errada">Ok</a>
              </div>
            </div>
        </div>
)}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(TimePauseModal);